import { render, staticRenderFns } from "./CreateWorkFlow.vue?vue&type=template&id=1cb3d660"
import script from "./CreateWorkFlow.vue?vue&type=script&lang=js"
export * from "./CreateWorkFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports